module.exports = __webpack_public_path__ + "static/media/Polygon-orange.af497285.svg";